import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  PropertyResponse,
  Property,
  AddPropertyResponse,
  PropertyCommonResponse,
} from '@core/interface/property';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  constructor(private http: HttpClient) {}

  getProperties(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<PropertyResponse>(environment.endPoints.propertyList, {
      params: httpParams,
    });
  }

  addProperty(data: Property) {
    return this.http.post<AddPropertyResponse>(
      environment.endPoints.propertyAddEdit,
      data
    );
  }
  deleteProperty(id: number) {
    return this.http.get<PropertyCommonResponse>(
      environment.endPoints.propertyDelete(id)
    );
  }
}
